define('models/pages/organization/users',['require','models/base/model','models/base/collection'],function(require) {
    'use strict';

    var Model = require('models/base/model'),
        Collection = require('models/base/collection');

    var UserItem = Model.extend({
        defaults: {
            Active: false,
            FIO: '',
            Nick: ''
        }
    });

    var OrganizationUsersCollection = Collection.extend({
        model: UserItem
    });

    var OrganizationUsers = Model.extend({
        urlPath: '/page/organization/users',
        defaults: {
            selected: null
        },
        constructor: function(data) {
            var _this = this;

            var users = new OrganizationUsersCollection(data ? data.users : [], { parse: true });

            this.users = users;

            users.on('change:selected', function(model, value) {
                if (value) {
                    users.each(function(item) {
                        if (item !== model && item.get('selected')) {
                            item.set('selected', false);
                        }
                    });
                    _this.set('selected', model);
                }
            });

            users.on('delete', function() {
                _this.trigger('delete');
            });

            Model.apply(this, arguments);
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.users.dispose();
            Model.prototype.dispose.apply(this, arguments);
        },
        parse: function(data) {
            var selected = this.get('selected');
            this.users.reset(data, { silent: true });
            if (selected) {
                var found = this.users.findWhere({ ID: selected.get('ID') });
                if (found) {
                    found.set('selected', true);
                }
            }
            return {};
        }
    });

    return OrganizationUsers;
});
